import { Injectable } from '@angular/core';
import { readStory, Story, StoryStatus, StoryType } from '../interfaces/story';
import { User } from "@angular/fire/auth";
import { ConsoleLoggerService } from '../../core/services/console-logger.service';

@Injectable({ providedIn: 'root' })
export class StoryService {
  private domparser = new DOMParser();

  constructor(private cLog: ConsoleLoggerService) {}

  parseEditorContent(editor: any, story: Story) {
    const htmlContent = editor.getData();
    const domDoc = this.domparser.parseFromString(htmlContent, 'text/html');

    story.content = htmlContent;

    /* Set Title */
    if (domDoc.getElementsByTagName('h1').length > 0) {
      story.title = domDoc.getElementsByTagName('h1')[0].innerText;
    }

    /* Set Byline */
    if (!story.created) {
      story.byline = domDoc.body.children[1].innerHTML;
    }

    return story;
  }

  calculateStoryReadTime(story: Story, storyWordCount: number) {
    let actual_read_time = storyWordCount / 200;
    let whole_read_time = ~~(actual_read_time);
    if (whole_read_time<=0) whole_read_time = 1;
    story.readTime = whole_read_time;
    return story;
  }

  public isStoryOwner(user: User | null, story: Story): boolean {
    if (
      user == null
      || !story
      || !story.roles
    ) return false;
    const userID = user?.uid;
    const storyRoles = story.roles!;
    return storyRoles[userID!] === "owner";
  }

  public sort(stories: readStory[], sortBy: 'asc' | 'desc'): readStory[] {
    switch(sortBy) {
      case 'asc': {
        return stories.sort(
          (a: readStory, b: readStory) =>
            /* Show the oldest stories first (asc) */
            new Date(a.created ? a.created?.seconds * 1000 : Date.now()).getTime()
            - new Date(b.created ? b.created?.seconds * 1000 : Date.now()).getTime()
        );
      }
      case 'desc': {
        return stories.sort(
          (a: readStory, b: readStory) =>
            /* Show the newest stories first (desc) */
            new Date(b.created ? b.created?.seconds * 1000 : Date.now()).getTime()
            - new Date(a.created ? a.created?.seconds * 1000 : Date.now()).getTime()
        );
      }
      default: {
        this.cLog.warn(`stories not sorted because sortBy parameter was expecting 'asc' or 'desc'`, sortBy);
        return stories;
      }
    }
  }

  public getStoriesTags(stories: readStory[]): string[] {
    const storyTags: string[] = [];

    for (let story of stories) {
      for (let tag of story.tags ?? []) {
        if (!storyTags.includes(tag)) storyTags.push(tag);
      }
    }

    return storyTags;
  }

  public getStoriesTypes(stories: readStory[]): StoryType[] {
    const storyTypes = stories.map(story => story.type);

    return [...new Set(storyTypes)];
  }

  public getStoriesStatuses(stories: readStory[]): StoryStatus[] {
    const storyStatuses = stories.map(story => story.status);

    return [...new Set(storyStatuses)];
  }
}
